import { motion } from 'framer-motion';
import { CheckIcon, PlusIcon, ArrowDownIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { TrustLine } from './TrustLine';
import { CHECKOUT, PRICE, comboIncludes, proProducts } from '../data/content';
const EASE = [0.23, 1, 0.32, 1] as const;
export function OffersSection() {
  return <section id="ofertas" className="scroll-mt-4 bg-noche px-5 py-14 sm:px-8 lg:py-18" data-id="element-103" data-mp="yvixbkre3o14">
      <div className="mx-auto max-w-6xl" data-id="element-104" data-mp="b553ppt5ph4f">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.4,
        ease: EASE
      }} className="text-center" data-id="element-105" data-mp="65itlp8mkgzu">
          <h2 className="font-display text-2xl font-black uppercase leading-tight text-crudo sm:text-3xl lg:text-4xl" data-id="element-106" data-mp="f4nqys8ga4af">
            Elegí cómo querés aprender
          </h2>
          <p className="mx-auto mt-3 max-w-lg text-sm leading-relaxed text-aluminio sm:text-base" data-id="element-107" data-mp="3jl89fq0pkvq4">
            Dos opciones según el nivel de contenido que quieras llevarte.
          </p>
        </motion.div>

        {/* PRO gets the wider column so it reads as the main path */}
        <div className="mt-9 grid items-stretch gap-4 lg:grid-cols-[0.85fr_1.15fr] lg:gap-6" data-id="element-108" data-mp="12dfddju2n4hs">
          {/* ------------------------------ Esencial ------------------------------ */}
          <motion.article initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.4,
          ease: EASE
        }} className="flex flex-col rounded-2xl border border-crudo/10 bg-industrial p-5 sm:p-6" data-id="element-109" data-mp="9pb7oybi2rf3">
            <span className="w-fit rounded-md bg-crudo/10 px-2.5 py-1 font-display text-[0.65rem] font-extrabold uppercase tracking-wider text-aluminio" data-id="element-110" data-mp="onlncy6tye6h">
              Esencial
            </span>

            <h3 className="mt-3 font-display text-lg font-black uppercase leading-tight text-crudo sm:text-xl" data-id="element-111" data-mp="200o69zwejftt">
              Super Combo
            </h3>
            <p className="mt-2 text-sm leading-relaxed text-aluminio/70" data-id="element-112" data-mp="1apxoea7fti">
              Todo el recorrido para aprender carpintería en aluminio desde
              cero.
            </p>

            <ul className="mt-5 grid gap-2 border-t border-crudo/10 pt-5" data-id="element-113" data-mp="8y1vcreq470r">
              {comboIncludes.map(item => <li key={item} className="flex items-start gap-2 text-sm text-aluminio" data-id="element-114" data-mp="3de4gep8l2e6y">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-aluminio/50" aria-hidden="true" data-id="element-115" data-mp="38gkpaoqse6xl" />
                  {item}
                </li>)}
            </ul>

            <div className="mt-auto pt-6" data-id="element-116" data-mp="3he4s424asbab">
              <p className="text-[0.7rem] font-extrabold uppercase tracking-wider text-aluminio/60" data-id="element-117" data-mp="2tplow103uop3">
                12 recursos digitales
              </p>
              <p className="mt-3 font-display text-3xl font-black leading-none text-crudo" data-id="element-118" data-mp="2pmyym4j31bu0">
                {PRICE.combo} <span className="text-sm font-bold" data-id="element-119" data-mp="2kbl7n5zfqg02">ARS</span>
              </p>
              <p className="mt-1.5 text-[0.7rem] font-semibold uppercase tracking-wider text-aluminio/60" data-id="element-120" data-mp="2kdo7siuaxpii">
                Pago único
              </p>

              <div className="mt-5" data-id="element-121" data-mp="2akyudif6y1kj">
                <CtaButton href={CHECKOUT.combo} label={`Elegir Super Combo — ${PRICE.combo}`} variant="secondary" data-id="element-122" data-mp="2am1py3ngks6s" />
              </div>
            </div>
          </motion.article>

          {/* -------------------------------- PRO -------------------------------- */}
          <motion.article initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.4,
          delay: 0.06,
          ease: EASE
        }} className="flex flex-col rounded-2xl border-2 border-electrico bg-industrial p-5 shadow-[0_0_70px_-20px_rgba(37,99,235,0.85)] sm:p-7" data-id="element-123" data-mp="2tbzuwavym567">
            <span className="w-fit rounded-md bg-electrico px-3 py-1 font-display text-[0.7rem] font-extrabold uppercase tracking-wider text-white" data-id="element-124" data-mp="1tdsl08wdhwem">
              🔥 Más completo
            </span>

            <h3 className="mt-3 font-display text-2xl font-black uppercase leading-tight text-crudo sm:text-3xl" data-id="element-125" data-mp="1jfl7y157fyhw">
              Super Combo PRO
            </h3>
            <p className="mt-2 font-display text-xs font-extrabold uppercase tracking-wider text-electrico-light sm:text-sm" data-id="element-126" data-mp="2h2brqjzry14l">
              Todo el Super Combo + 2 productos PRO
            </p>

            <ul className="mt-5 grid gap-2 border-t border-crudo/10 pt-5 sm:grid-cols-3" data-id="element-127" data-mp="2732thexvm0cf">
              {['Los 6 Tomos', 'Los 6 Bonos', 'Todo el contenido de la versión anterior'].map(item => <li key={item} className="flex items-start gap-2 text-sm text-aluminio" data-id="element-128" data-mp="qpmdfq88r95u">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-verde-light" aria-hidden="true" data-id="element-129" data-mp="32by0vsb0q87w" />
                  {item}
                </li>)}
            </ul>

            <div className="mt-5 flex items-center gap-3" data-id="element-130" data-mp="3h3fbkgl7657b">
              <span className="h-px flex-1 bg-electrico/40" data-id="element-131" data-mp="3h506467iho56" />
              <PlusIcon className="h-4 w-4 text-electrico-light" aria-hidden="true" data-id="element-132" data-mp="3m0yq7hlt4jzs" />
              <span className="h-px flex-1 bg-electrico/40" data-id="element-133" data-mp="3q5ojcyp2zkh0" />
            </div>

            <div className="mt-4 grid gap-3 sm:grid-cols-2" data-id="element-134" data-mp="3v37xlyls3x8y">
              {proProducts.map(product => <div key={product.title} className="overflow-hidden rounded-xl border border-electrico/30 bg-noche" data-id="element-135" data-mp="3vlymja08iyf">
                  <img src={product.image} alt={product.alt} className="aspect-[16/9] w-full object-cover" loading="lazy" data-id="element-136" data-mp="25otafiqesifk" />
                  <div className="p-3.5" data-id="element-137" data-mp="1tn1vb4j7i0ni">
                    <h4 className="font-display text-xs font-extrabold uppercase leading-snug text-crudo sm:text-sm" data-id="element-138" data-mp="27kyrw0xnu726">
                      <span aria-hidden="true" data-id="element-139" data-mp="22lvw773kld6v">{product.icon}</span>{' '}
                      {product.title}
                    </h4>
                    <p className="mt-1.5 text-[0.7rem] leading-relaxed text-aluminio/70 sm:text-xs" data-id="element-140" data-mp="2gkddalyyzrft">
                      {product.description}
                    </p>
                  </div>
                </div>)}
            </div>

            {/* In-card upgrade math */}
            <div className="mt-6 rounded-xl border border-crudo/10 bg-noche p-4" data-id="element-141" data-mp="2ldy49u25bl5i">
              <div className="flex items-center justify-between text-xs text-aluminio/60" data-id="element-142" data-mp="30ayyq5bq1u7o">
                <span className="font-semibold uppercase tracking-wider" data-id="element-143" data-mp="2vbm2ityynasf">
                  Super Combo
                </span>
                <span data-id="element-144" data-mp="3ex4eckwrj8xe">12 recursos · {PRICE.combo}</span>
              </div>

              <div className="my-2.5 flex items-center gap-2" data-id="element-145" data-mp="3iyhhuocdv015">
                <ArrowDownIcon className="h-3.5 w-3.5 shrink-0 text-verde-light" aria-hidden="true" data-id="element-146" data-mp="34yf4nff0sus8" />
                <span className="font-display text-[0.7rem] font-extrabold uppercase tracking-wider text-verde-light" data-id="element-147" data-mp="39w8ecifj86x9">
                  Por solo $7.000 más
                </span>
              </div>

              <div className="flex items-center justify-between text-xs font-bold text-crudo" data-id="element-148" data-mp="300wujlp9o9in">
                <span className="font-display uppercase tracking-wider" data-id="element-149" data-mp="2m98gvdzddczk">
                  Super Combo PRO
                </span>
                <span data-id="element-150" data-mp="2r4xjjq6ora03">14 recursos · {PRICE.pro}</span>
              </div>
            </div>

            <div className="mt-auto pt-6" data-id="element-151" data-mp="2cbufmlm0ouru">
              <p className="font-display text-sm font-extrabold uppercase tracking-wider text-electrico-light" data-id="element-152" data-mp="2h9dqrcnf4rfk">
                Todo el sistema + expansión PRO
              </p>
              <p className="mt-2 font-display text-5xl font-black leading-none text-crudo sm:text-6xl" data-id="element-153" data-mp="2spac0k65ocum">
                {PRICE.pro} <span className="text-lg font-bold" data-id="element-154" data-mp="2npnzkcy5j0mv">ARS</span>
              </p>
              <p className="mt-1.5 text-[0.7rem] font-semibold uppercase tracking-wider text-aluminio/60" data-id="element-155" data-mp="2ir2zqemtaiyy">
                Pago único
              </p>

              <div className="mt-5" data-id="element-156" data-mp="2dst27xdm76a6">
                <CtaButton href={CHECKOUT.pro} label={`Quiero el Super Combo PRO — ${PRICE.pro}`} size="xl" data-id="element-157" data-mp="2dtugsbtuaawn" />
              </div>
              <div className="mt-4" data-id="element-158" data-mp="24xbmow9vggyh">
                <TrustLine data-id="element-159" data-mp="201e8owm2zmov" />
              </div>
            </div>
          </motion.article>
        </div>
      </div>
    </section>;
}